import { nextRandom } from './rng';

// A six-sided die as a value 1-6. Returns [value, nextRngState].
export function rollDie(rngState) {
  const [value, nextState] = nextRandom(rngState);
  return [Math.floor(value * 6) + 1, nextState];
}

// Returns [[d1, d2], nextRngState].
export function rollTwoDice(rngState) {
  const [d1, afterFirst] = rollDie(rngState);
  const [d2, afterSecond] = rollDie(afterFirst);
  return [[d1, d2], afterSecond];
}
